const LogoutIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_239_198)">
        <path
          d="M13.5715 14.9996V17.8567C13.5715 18.2356 13.421 18.599 13.1531 18.8669C12.8852 19.1347 12.5218 19.2853 12.1429 19.2853H2.14293C1.76404 19.2853 1.40068 19.1347 1.13277 18.8669C0.864865 18.599 0.714355 18.2356 0.714355 17.8567V2.14244C0.714355 1.76355 0.864865 1.4002 1.13277 1.13229C1.40068 0.864377 1.76404 0.713867 2.14293 0.713867H12.1429C12.5218 0.713867 12.8852 0.864377 13.1531 1.13229C13.421 1.4002 13.5715 1.76355 13.5715 2.14244V4.99958"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.28589 10H19.2859"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.4287 7.14258L19.2859 9.99972L16.4287 12.8569"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_239_198">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LogoutIcon;
